<mpsm-clinic-supplier-list
  [resultCount]="(resultCount$ | async) ?? 0"
  [isProcessingExport]="(isProcessingExport$ | async) ?? false"
  [dataSource]="dataSource"
  (searched)="handleSearch($event)"
  (exportClicked)="exportAll()"
/>
